import { FC } from 'react';
import { IllustrationWrapper } from '../IllustrationWrapper';
import { IllustrationProps } from '../Illustrations.types';

const StakePushGreyCoin: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName='StakePushGreyCoin'
      illustration={
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={restProps?.width ?? '24'}
          height={restProps?.height ?? '24'}
          viewBox='0 0 48 48'
          fill='none'
          {...props}
        >
          <ellipse
            cx='24.1157'
            cy='25.9366'
            rx='24'
            ry='22.5634'
            fill='black'
          />
          <ellipse
            cx='24.1157'
            cy='23.1644'
            rx='24'
            ry='22.6644'
            fill='#AEB4C9'
          />
          <ellipse
            cx='23.9341'
            cy='22.9961'
            rx='19.6577'
            ry='18.5638'
            fill='black'
          />
          <ellipse
            cx='23.9341'
            cy='25.5322'
            rx='19.6577'
            ry='18.8792'
            fill='#AEB4C9'
          />
          <path
            d='M24.1155 36.5248C25.5127 36.5248 26.7119 35.6877 27.2448 34.4885C27.3741 34.1965 27.1584 33.8678 26.8392 33.8678H21.3925C21.0733 33.8678 20.8562 34.1958 20.9869 34.4885C21.5198 35.6877 22.719 36.5248 24.1162 36.5248'
            fill='white'
          />
          <path
            d='M31.8825 30.2875C31.0593 30.2875 30.3922 29.6204 30.3922 28.7972V23.3836C30.3922 20.4497 28.3784 17.987 25.6582 17.2997C25.5583 16.5264 24.8989 15.9276 24.0978 15.9276C23.2967 15.9276 22.6321 16.5314 22.5366 17.3092C20.0954 17.9427 18.2327 20.009 17.8975 22.5572C17.8925 22.5945 17.8874 22.6311 17.883 22.6691C17.8767 22.7197 17.8716 22.7696 17.8678 22.8208C17.864 22.872 17.8596 22.9226 17.8564 22.9732C17.8533 23.0162 17.8501 23.0573 17.8482 23.1003C17.8444 23.1856 17.8419 23.2723 17.8419 23.3595V28.7966C17.8419 29.616 17.1812 30.2806 16.363 30.2869C15.9729 30.29 15.6504 30.591 15.6504 30.9824V30.9887C15.6504 31.3757 15.9646 31.6899 16.3516 31.6899H31.8793C32.2663 31.6899 32.5805 31.3757 32.5805 30.9887C32.5824 30.6024 32.2682 30.2881 31.8812 30.2881L31.8825 30.2875Z'
            fill='white'
          />
          <path
            d='M28.9541 16.2551C30.8338 16.658 32.2692 18.2757 32.4461 20.1909C32.4658 20.4032 32.651 20.5618 32.8674 20.5407C32.9702 20.5312 33.0634 20.4815 33.1301 20.4025C33.1954 20.3229 33.2274 20.2222 33.2179 20.1194C33.1138 19.0012 32.6632 17.9674 31.9139 17.1269C31.17 16.2946 30.2029 15.7311 29.116 15.4976C29.0888 15.4922 29.0616 15.4888 29.0351 15.4888C28.8567 15.4888 28.6948 15.6133 28.6567 15.795C28.6117 16.004 28.7451 16.2095 28.9541 16.2544V16.2551Z'
            fill='white'
          />
          <path
            d='M29.3887 13.7627C32.3131 14.3895 34.5481 16.9083 34.8245 19.8865C34.8442 20.0988 35.0293 20.2561 35.2457 20.2363C35.3485 20.2268 35.4417 20.1771 35.5084 20.0982C35.5738 20.0185 35.6058 19.9178 35.5962 19.815C35.4445 18.1687 34.7789 16.6436 33.6736 15.4069C32.5772 14.1792 31.1514 13.3489 29.552 13.0052C29.5248 12.9997 29.4976 12.9963 29.471 12.9963C29.2927 12.9963 29.1308 13.1209 29.0926 13.3026C29.0464 13.5115 29.1804 13.7171 29.3894 13.762L29.3887 13.7627Z'
            fill='white'
          />
          <path
            d='M19.2748 16.2549C19.4837 16.21 19.6171 16.0031 19.5722 15.7942C19.5327 15.6125 19.3721 15.4879 19.1938 15.4879C19.1672 15.4879 19.14 15.4913 19.1128 15.4968C18.0266 15.7295 17.0595 16.293 16.3149 17.1261C15.5656 17.9652 15.1137 19.0004 15.011 20.1186C15.0014 20.2213 15.0327 20.3221 15.0987 20.4017C15.1641 20.4813 15.2587 20.531 15.3615 20.5398C15.5792 20.5596 15.763 20.4017 15.7827 20.19C15.9597 18.2776 17.3964 16.6592 19.2748 16.2556V16.2549Z'
            fill='white'
          />
          <path
            d='M18.8407 13.7627C19.0496 13.7178 19.183 13.5109 19.1381 13.302C19.0986 13.1203 18.938 12.9957 18.7597 12.9957C18.7325 12.9957 18.7059 12.9991 18.6787 13.0046C17.078 13.3483 15.6535 14.1786 14.5571 15.4063C13.4519 16.6436 12.7876 18.1681 12.6345 19.8144C12.625 19.9172 12.6563 20.0179 12.7223 20.0976C12.7876 20.1772 12.8822 20.2269 12.985 20.2357C13.2014 20.2554 13.3865 20.0976 13.4063 19.8859C13.6819 16.909 15.9169 14.3916 18.8407 13.7634V13.7627Z'
            fill='white'
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default StakePushGreyCoin;
